import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { useAuth } from '../contexts/AuthContext';
import { setupAnalytics, trackEvent } from '../services/analyticsService';

const AnalyticsTracker: React.FC = () => {
  const location = useLocation();
  const { language } = useLanguage();
  const { user } = useAuth();

  useEffect(() => {
    setupAnalytics(language, user?.id);
  }, [language, user?.id]);

  useEffect(() => {
    trackEvent('page_view', {
      language,
      user_id: user?.id,
      metadata: { path: location.pathname },
    });
    if (location.pathname === '/') {
      trackEvent('site_enter', { language, user_id: user?.id });
    }
  }, [location.pathname, language, user?.id]);

  return null;
};

export default AnalyticsTracker;
